import { forwardRef, type InputHTMLAttributes } from 'react';
import Input from 'react-phone-number-input/input';
import { cn } from '../lib/utils';

export interface PhoneNumberInputProps {
  value?: string;
  onChange: (value: string | undefined) => void;
  id?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

// Styled input matching app design
const StyledInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
);

StyledInput.displayName = 'StyledInput';

export default function PhoneNumberInput({
  value,
  onChange,
  id,
  placeholder = "(555) 123-4567",
  disabled,
  required,
  className,
}: PhoneNumberInputProps) {
  return (
    <Input
      id={id}
      value={value}
      onChange={onChange}
      defaultCountry="US"
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      inputComponent={StyledInput}
      className={className}
    />
  );
}
